export default __webpack_public_path__ + "892e363b414fe9de9c43057ef03b571c.svg";